import { useEffect } from "react";
import { useDispatch } from "react-redux";

import {
  getCourseSectionsFetchSuccess,
  getSectionFetchSuccess
} from "seneca-common/features/course/state";
import { useSelectorWithArgs } from "seneca-common/utils/hooks/selectors";

import { expandAllParentsForLeafSection } from "features/classroom/actions";

export default function useExpandSidebarSectionEffect(
  courseId: string,
  sectionId: string | null | undefined
) {
  const dispatch = useDispatch();

  const courseSectionsFetchSuccess = useSelectorWithArgs(
    getCourseSectionsFetchSuccess,
    courseId
  );

  const sectionFetchSuccess = useSelectorWithArgs(
    getSectionFetchSuccess,
    sectionId
  );

  useEffect(() => {
    if (sectionId && courseSectionsFetchSuccess && sectionFetchSuccess) {
      dispatch(expandAllParentsForLeafSection(courseId, sectionId));
    }
  }, [
    dispatch,
    courseId,
    sectionId,
    courseSectionsFetchSuccess,
    sectionFetchSuccess
  ]);
}
